import * as React from 'react';
import { cn } from '../lib/utils';

const CrmPage = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('crm-page min-w-0 space-y-[var(--crm-page-section-gap)]', className)}
      {...props}
    />
  )
);
CrmPage.displayName = 'CrmPage';

const CrmPageShell = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('crm-page-shell space-y-6', className)} {...props} />
  )
);
CrmPageShell.displayName = 'CrmPageShell';

const CrmPageHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'crm-page-header border-border/60 flex flex-wrap flex-col gap-[var(--crm-component-gap)] border-b pb-4 sm:flex-row sm:items-start sm:justify-between',
        className
      )}
      {...props}
    />
  )
);
CrmPageHeader.displayName = 'CrmPageHeader';

const CrmPageHeading = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('crm-page-heading min-w-0 space-y-1', className)} {...props} />
  )
);
CrmPageHeading.displayName = 'CrmPageHeading';

const CrmPageTitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h1
      ref={ref}
      className={cn(
        'crm-page-title text-foreground font-display flex max-w-full items-start gap-2.5 text-[1.625rem] leading-[1.16] font-normal sm:items-center sm:text-[1.75rem] [&_svg]:mt-0.5 [&_svg]:h-6 [&_svg]:w-6 [&_svg]:shrink-0 sm:[&_svg]:mt-0 sm:[&_svg]:h-7 sm:[&_svg]:w-7',
        className
      )}
      {...props}
    />
  )
);
CrmPageTitle.displayName = 'CrmPageTitle';

const CrmPageDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('crm-page-description text-muted-foreground max-w-3xl text-sm', className)}
    {...props}
  />
));
CrmPageDescription.displayName = 'CrmPageDescription';

const CrmPageActions = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'crm-page-actions flex w-full flex-wrap gap-2 sm:w-auto sm:shrink-0 sm:justify-end [&>*]:min-w-0 [&>*]:flex-1 sm:[&>*]:flex-none',
        className
      )}
      {...props}
    />
  )
);
CrmPageActions.displayName = 'CrmPageActions';

export {
  CrmPage,
  CrmPageShell,
  CrmPageHeader,
  CrmPageHeading,
  CrmPageTitle,
  CrmPageDescription,
  CrmPageActions,
};
